module.exports = __webpack_public_path__ + "img/funny.58463eba.png";